export default {
    link: "guia2026",
    name: "Guia 2026",
    title: 'Guia 2026',

    paywall: {
        title: "Descubra o guia definitivo para o ano de 2026",

        benefits: {
            title: "VOCÊ VAI TER ACESSO ILIMITADO A:",
            predictions:"<strong>Previsões pessoais e globais para 2026</strong>",
            tips:"<strong>Dicas personalizadas</strong> para o seu sucesso pessoal",
            analysis:"<strong>Conteúdos exclusivos</strong> - visão astro-geopolítica, numerologia do ano, análise do momento astrológico e ciclos planetários atuais",
            councils:"<strong>Conselhos do Tarot</strong> para orientar seus passos ao longo do ano",
            contents:"<strong>Calendários de Eventos Astrológicos de 2026</strong>",
            calendar:"Agora também com os <strong>conteúdos em áudio</strong>",
            audioAvailable: "Novidade: agora o conteúdo também está <strong>disponível em áudio</strong>",
            audioIconAlt: "Ícone de fone de ouvido",
            items: {
                calendar: {
                    title: "Calendário Pessoal",
                    text: "Mês a mês, saiba o que pode travar seu 2026 e como virar a maré a seu favor"
                },
                predictions: {
                    title: "Previsões personalizadas",
                    text: "Para seu Signo Solar e Ascendente: relacionamentos, dinheiro, família e saúde"
                },
                tarot: {
                    title: "Conselhos do Tarot",
                    text: "Descubra o que O Mago traz para 2026, além de conselhos para o seu signo"
                },
                overview: {
                    title: "Panorama completo de 2026",
                    text: "Roteiro do ano com prioridades, riscos e oportunidades"
                },
                astrogeopolitics: {
                    title: "Astrogeopolítica",
                    text: "Nossa análise sempre certeira para Brasil e para o mundo"
                },
                keyDates: {
                    title: "Datas-chave e calendários",
                    text: "Eclipses, fases da Lua e retrogradações"
                },
                yearOne: {
                    title: "O Ano 1 na Numerológia",
                    text: "Insights poderosos para mudar sua vida com a energia do momento"
                }
            }
        },

        subtitle: "Clientes Astrolink Premium têm esses e muitos outros recursos",

        hero: {
            header: "Descubra o guia definitivo para o ano de 2026",
            subtitle: "Clientes Astrolink Premium têm esses e muitos outros recursos"
        },

        info:{
            description: "Este será um ano repleto de dinamismo, e com nosso guia atualizado, você aprenderá a utilizar a astrologia de forma poderosa ao longo de toda a sua jornada.<br /><br /><strong>Permita-nos guiá-lo nessa jornada incrível!</strong>",
            cta: "Quero Ler Agora!"
        },

        notSubscriber: {
            description: "Assinantes Premium pagam apenas <strqng>{maxInstallments}x {installmentValue} no Mapa do Amor</strqng> e ganham 30% OFF em qualquer conteúdo extra!",
            descriptionApp: "Assinantes Premium pagam apenas <strong>{discountedPrice} no Mapa do Amor</strong> e ganham 30% OFF em qualquer conteúdo extra!",
        },

        buy: {
            info: "Adquira seu guia de 2026 personalizado em uma <strong>compra única</strong> e leia sempre que quiser",

            ios: {
                discountForSubscriber: "DE <span>{fullPrice}</span> POR",
                moreOptions: 'Opções de parcelamento sem juros disponíveis!',
                link: 'Compre direto no site',
                ctaLink: 'mapa-dqo-amor',
            },
        },

        cta1: "EU QUERO!",
        cta2: "Quero Ler Agora!"
    },

    paywallOTS: {
        hero: {
            alt: "Ilustração de uma menina em um mundo mágico com elementos astrológicos ao redor. Em cima está escrito \"Guia do ano 2026\" e abaixo \"Garanta a ferramenta que vai mudar sua vida pelo menor preço do ano!\""
        },

        limitedOffer: 'PROMOÇÃO',
        mainTitle: "Suas previsões personalizadas para 2026 já estão prontas, acesse agora!",

        payment: {
            callout: {
                subscriber: 'DESCONTO BÔNUS DE CLIENTE PREMIUM',
                nonSubscriber: 'MENOR PREÇO! ECONOMIA DE 80%'
            },
            from: "<del>De {fullPrice}</del> por apenas",
            price: "<span></span><span>{value}</span>",
            installments: "<span>{installments}x</span><span>{installmentValue}</span>",
            cash: "sem juros ou à vista: <b>{cashPrice}</b>",
            cashOnly: "De {fullPrice} por apenas {cashPrice}",
            details: "Acesso imediato ⭐ | Garantia de 7 dias 🏆 | Compra segura 🔒",
            detailsDesktop: "Acesso imediato ⭐ | Garantia de 7 dias 🏆<br/>Compra segura 🔒",
            bonus: "+BÔNUS: CUPOM DE 50% OFF NO PREMIUM 🎁"
        },

        paymentButtons: {
            installments: "Parcelamento em até {installments}x sem juros",
            creditCard: "Comprar com Cartão",
            pixWeb: "Comprar com PIX em 1 clique",
            pixApp: "Comprar com PIX"
        },

        whyUs: {
            title: "Por que o Guia 2026 do Astrolink é o melhor para você?",
            items: {
                0: {
                    bold: "Foco em ação prática:",
                    text: "com datas e oportunidades reais de transformação."
                },
                1: {
                    bold: "Personalizado para você:",
                    text: "nada de previsões genéricas!"
                },
                2: {
                    bold: "Criado por especialistas:",
                    text: "conteúdo didático e focado nas suas necessidades."
                },
                3: {
                    bold: "Materiais BÔNUS:",
                    text: "calendários astrológicos que te preparam para tudo!"
                }
            }
        },

        testimonials: {
            title: "Mais de <strong>50.000</strong> pessoas já estão aproveitando as vantagens que o Guia 2026 proporciona!",
            subtitle: "Quem acessou as previsões personalizadas já sabe o segredo para prosperar no amor, carreira e família.",
            items: {
                0: {
                    text: "Nunca imaginei que as previsões fossem tão precisas. O Guia me ajudou a sair de algumas ciladas e aproveitar oportunidades que eu nem sabia que existiam.",
                    name: "Márcia",
                    sign: "Aquariana"
                },
                1: {
                    text: "Fui extremamente feliz lendo cada frase dentro dessa análise, como se um velho amigo que conhece todas as minhas dores estivesse me aconselhando. Gratidão!!!",
                    name: "André",
                    sign: "Canceriano"
                }
            }
        },

        comparison: {
            title: "Veja a diferença que o conhecimento das previsões faz na sua vida:",
            without: {
                title: "Sem o Guia 2026",
                items: {
                    0: "Insegurança sobre relacionamentos",
                    1: "Toma decisões erradas por falta de clareza",
                    2: "Perde oportunidades por não saber quando e como agir",
                    3: "Ansiedade constante sobre o futuro",
                    4: "Repete os mesmos padrões que te levam a decepção",
                    5: "Erra em investimentos e finanças.",
                    6: "Os anos vão passando e você não aproveita"
                }
            },
            with: {
                title: "Com o Guia 2026",
                items: {
                    0: "<b>Clareza total</b> sobre relacionamentos e compatibilidade",
                    1: "Toma decisões certas com <b>confiança</b>",
                    2: "Aproveita as <b>melhores oportunidades</b> do ano",
                    3: "Paz de espírito e <b>segurança sobre o futuro</b>",
                    4: "Quebra ciclos negativos e cria <b>novos padrões</b> saudáveis",
                    5: "Investe certo e <b>multiplica seu dinheiro</b>",
                    6: "<b>2026 é seu melhor ano até agora!</b>"
                }
            }
        },

        subscriberAdvantages: {
            discount: "Garanta agora suas previsões personalizadas com <b>{discount}% de desconto!</b>",
            buyOnce: "Adquira seu guia 2026 personalizado em <b>uma compra única</b> e leia sempre que quiser",
            anchor: "Quero meu Guia 2026 com {discount}% OFF",
            title: "VANTAGENS PARA ASSINANTES",
            description: "Além de <b>desconto em todos os produtos</b> de compra única, assinantes tem <b>acesso a todas as ferramentas ilimitadas:</b> adicionais do Mapa Astral, Mapas Extras, Compatibilidades, Ciclo Lunar, Tarot e Biorritmo!"
        },

        terms: {
            text: "Ao comprar produtos do Astrolink você concorda com os nossos",
            link: "Termos de Uso"
        },

        result: {
            success: {
                title: "Compra Efetuada!",
                email: "Você receberá uma confirmação no seu e-mail de cadastro",
                loveMapDiscount: 'Mapa do Amor (30% de desconto)',
                subscribe: {
                    title: "Seu Cupom de Desconto",
                    discount: "Assine o Astrolink Premium em qualquer plano com 50% de desconto! Cupom válido por 30 dias",
                    subscribeButton: "Escolha seu plano",
                    
                    app: {
                        title: "Torne-se Premium",
                        discount: "Assine o Astrolink Premium e garanta seu acesso a ferramentas e descontos exclusivos!",
                    },
                },
                guide: {
                    title: "O Guia 2026 já está disponível!",
                    message: "Acesse quando quiser pelo menu <em>Explorar</em>",
                    readButton: "Leia seu Guia 2026"
                }
            },
            error: {
                title: "Erro ao efetuar a compra 😕",
                message: "<strong>{userName}</strong>, infelizmente ocorreu um erro, pedimos que você verifique as informações inseridas e se o problema persistir, nos contate através do nosso <a href=\"{supportUrl}\">suporte</a>",
                backButton: "Voltar"
            }
        }
    }
}